import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.758 11.042 15.8 10a3.536 3.536 0 0 0-5-5L9.758 6.042M6.841 8.958 5.8 10a3.536 3.536 0 0 0 5 5l1.041-1.042m.834-5.833-3.75 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);